import { isDesktopOnlyTargeted } from 'modules/campaigns/modules/common-campaign-form/components/InventoryTypeTargeting/inventoryTypeTargetingUtils';
import { TARGETING_TYPES } from 'modules/campaigns/modules/common-campaign-form/config';

const transformInventoryTypeTargetingToGW = campaign => {
    const { platformTargeting } = campaign;

    if (!isDesktopOnlyTargeted(platformTargeting)) {
        return campaign;
    }

    return {
        ...campaign,
        campaignTargeting: {
            ...campaign.campaignTargeting,
            inventoryTypeTargeting: {
                type: TARGETING_TYPES.ALL,
                values: [],
            },
        },
    };
};

export { transformInventoryTypeTargetingToGW };
